<kpd-detail-entity-tabs
  [facade]="licenseFacade"
  [navigatorHelper]="navigatorHelper"
  (close)="onClose()"
  (itemChanged)="onItemChanged($event.item)"
  [entityTypeName]="'License' | translate"
  [viewMode]="viewMode"
>
  <kpd-detail-tab [title]="'General' | translate" name="general">
    <ng-template>
      <app-license-details-general [item]="currentItem"></app-license-details-general>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [title]="'Users' | translate"
    name="users"
    icon="users"
    [badge]="tabLabels.userCount.toString()"
    *kpdPermission="Permissions.UserRead"
  >
    <ng-template>
      <app-license-details-users
        [license]="currentItem"
        (switchMode)="onSwitchMode($event)"
        (itemChanged)="changeTabLabel('userCount', $event)"
      ></app-license-details-users>
    </ng-template>
  </kpd-detail-tab>
</kpd-detail-entity-tabs>
